/**
 * Enum representing animation direction for panel transitions.
 */
export enum StoryPanelDirection {
	LEFT = 'left',
	RIGHT = 'right',
}
